import UserLayout from "../../../layouts/user";
import PromotionList from "./_components/PromotionList";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ডিসকাউন্ট",
  },
];

export default function UserDiscount() {
  return (
    <UserLayout title="ডিসকাউন্ট" breadcrumb={breadcrumb}>
      <PromotionList />
    </UserLayout>
  );
}
